import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CRow,
  CCol,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormInput,
  CFormSelect,
} from '@coreui/react';
import React, { useEffect, useRef, useState } from 'react';

import './ScenePasscode.scss';
import adminApi from 'services/adminApi';
import ModalConfirm from '../components/ModalConfirm';

export default function ScenePasscode() {
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);

  const refIdEdit = useRef(null);
  const refPassword = useRef(null);
  const refLevel = useRef(null);
  const refModalConfirm = useRef(null);

  const getListData = async () => {
    const res = await adminApi({ url: '/password' });
    const result = await res.json();
    setData(result.data.map((item) => ({ ...item, isShow: false })));
  };

  const handleNewClick = () => {
    refIdEdit.current = null;
    setVisible(true);
  };

  const handleClickEdit = (id) => {
    refIdEdit.current = id;
    setVisible(true);
  };

  const handleDelete = (id) => {
    refModalConfirm.current.open({
      visible: true,
      dataConfirm: id,
      title: 'Delete Passcode',
      description: 'Are you sure you want to delete this passcode?',
    });
  };

  const handleDeleteConfirm = async (id) => {
    const res = await adminApi({ url: `/password/${id}`, method: 'DELETE' });
    const { isSuccess, message } = await res.json();
    if (!isSuccess) {
      alert(message);
      return;
    }
    setData((prev) => prev.filter((item) => item._id !== id));
    refModalConfirm.current.close();
  };

  const handleShowPassword = (id) => {
    setData((prev) =>
      prev.map((item) =>
        item._id === id ? { ...item, isShow: !item.isShow } : item
      )
    );
  };

  const handleUpdate = async () => {
    const password = refPassword.current.value;
    const level = refLevel.current.value || 1;
    const id = refIdEdit.current;

    if (!password || !level) {
      return;
    }

    if (!id) {
      const res = await adminApi({
        url: '/password',
        method: 'POST',
        body: { password, level },
      });
      const { isSuccess, data: finalData, message } = await res.json();
      if (!isSuccess) {
        alert(message);
        return;
      }
      setData((prev) => [...prev, finalData]);
      setVisible(false);
      return;
    }

    const res = await adminApi({
      url: `/password/${id}`,
      method: 'PUT',
      body: { password, level },
    });

    const { isSuccess, data: finalData, message } = await res.json();

    if (!isSuccess) {
      alert(message);
      return;
    }
    setData((prev) =>
      prev.map((item) => (item._id === id ? { ...item, ...finalData } : item))
    );
    setVisible(false);
  };

  useEffect(() => {
    getListData();
  }, []);

  return (
    <div className="admin-table">
      <CRow className="my-2">
        <CCol className="text-end">
          <CButton
            className="create-btn"
            style={{ fontSize: '12px' }}
            onClick={handleNewClick}
            color="success"
          >
            Create New
          </CButton>
        </CCol>
      </CRow>

      <div
        style={{
          padding: '15px 25px',
          backgroundColor: 'white',
          borderRadius: '5px',
          overflowX: 'auto',
        }}
      >
        <CTable className="bg-dark" style={{ fontSize: '13px' }}>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell
                className="align-middle"
                style={{ width: '50px' }}
              >
                #
              </CTableHeaderCell>
              <CTableHeaderCell className="align-middle">
                Password
              </CTableHeaderCell>
              <CTableHeaderCell className="align-middle">
                Level
              </CTableHeaderCell>
              <CTableHeaderCell
                className="align-middle"
                style={{ width: '150px' }}
              >
                Action
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {data.map(({ _id: id, password, isShow, level }, index) => (
              <CTableRow key={id}>
                <CTableHeaderCell scope="row" className="align-middle">
                  {index + 1}
                </CTableHeaderCell>
                <CTableDataCell className="align-middle">
                  {isShow
                    ? password
                    : Array(password.length).fill('*').join('')}
                </CTableDataCell>
                <CTableDataCell className="align-middle">
                  {level}
                </CTableDataCell>
                <CTableDataCell className="align-middle d-flex">
                  <CButton
                    className="edit-btn me-2"
                    color="success"
                    style={{ fontSize: '12px', width: '60px' }}
                    onClick={() => handleShowPassword(id)}
                  >
                    {isShow ? 'Hide' : 'Show'}
                  </CButton>
                  <CButton
                    className="edit-btn me-2"
                    color="info"
                    style={{ fontSize: '12px' }}
                    onClick={() => handleClickEdit(id)}
                  >
                    Edit
                  </CButton>
                  <CButton
                    className="delete-btn"
                    color="danger"
                    style={{ fontSize: '12px' }}
                    onClick={() => handleDelete(id)}
                  >
                    Delete
                  </CButton>
                </CTableDataCell>
              </CTableRow>
            ))}
          </CTableBody>
        </CTable>
      </div>
      <CModal visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Passcode</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CFormInput
            ref={refPassword}
            label="Password"
            type="text"
            size="sm"
            placeholder="Passcode"
            defaultValue={
              data.find((item) => item._id === refIdEdit.current)?.password ||
              ''
            }
            style={{ marginBottom: '10px' }}
          />
          <CFormSelect
            ref={refLevel}
            label="Level"
            size="sm"
            className="mb-3"
            defaultValue={
              data.find((item) => item._id === refIdEdit.current)?.level || 1
            }
          >
            <option>Select level</option>
            <option value="1">1</option>
            <option value="2">2</option>
            {/* <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option> */}
          </CFormSelect>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton color="success" onClick={handleUpdate}>
            Save
          </CButton>
        </CModalFooter>
      </CModal>
      <ModalConfirm ref={refModalConfirm} onConfirm={handleDeleteConfirm} />
    </div>
  );
}
